import React,{ useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { Input, Row, Anchor, Divider } from 'antd';
import { SearchOutlined } from '@ant-design/icons';


// getBlogInfo
import { getBlogInfo } from '../../api/article'

import './aBoutDetail.less'

const ABoutDetail = () =>{
  const location = useLocation();
  const navigate = useNavigate();

  const contentDom = useRef(null)
  
  const [selectArticle, setSelectArticle] = useState({})

  const [directoryList, setDirectoryList] = useState([])
   

  const getBlogInfoFn = async (id) =>{
    let res = await getBlogInfo(id)
    console.log('BlogInfo', res?.data)
    if(res?.msg === 'success'){
      const now = new Date(res?.data.publishedTime);
      const Y = now.getFullYear();
      const M = String(now.getMonth() + 1).padStart(2, '0'); // 月份从0开始，需要加1
      const D = String(now.getDate()).padStart(2, '0');
      const h = String(now.getHours()).padStart(2, '0');
      const m = String(now.getMinutes()).padStart(2, '0');
      const s = String(now.getSeconds()).padStart(2, '0');

      // 创建一个DOMParser对象
      const parser = new DOMParser();
      // 解析HTML字符串
      const doc = parser.parseFromString(res?.data.content, 'text/html');

      const allParagraphsText = Array.from(doc.querySelectorAll('h2')).map((e,i) => {
        return({
          key: i,
          href: 'page'+i,
          title: e.textContent,
          replace: true
        })
      });
      setDirectoryList(()=> allParagraphsText)

      Array.from(doc.querySelectorAll('h2')).forEach((e,i)=>{
        e.id = 'page'+i
      })

      setSelectArticle(()=> {
        return {
          taglist: ['News', 'Nutrition','Studies'],
          time: `${Y}-${M}-${D} ${h}:${m}:${s}`,
          title: res?.data.title,
          excerpt: res?.data.excerpt,
          img: <img src={res?.data.coverImage} style={{width: '100%',borderRadius:5}}/>,
          content: doc.body.innerHTML
        }
      })
    }
  }


  const [width, setWidth] = useState(window.innerWidth);
  useEffect(()=>{
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    console.log(id)
    if(id){
      getBlogInfoFn(id)
    }

    const handleResize = () => {
      setWidth(window.innerWidth);
    };
 
    // 添加事件监听器
    window.addEventListener('resize', handleResize);

    // 清理函数，组件卸载时移除事件监听器
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [])

  const scrollToAnchor = anchorName => {
    if (anchorName) {
      console.log(anchorName, document)
      // 找到锚点
      const anchorElement = document.getElementById(anchorName)
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' })
      }
    }
  }
  if(width > 770){
    return (
      <div className="ABoutDetail-page" style={{textAlign: 'left'}}>
        <div style={{width: '100%', maxWidth: 1440, margin: '0px auto'}}>
  
          {/* 科技前沿内容 + 科技前沿目录 */}
          <div style={{ display: 'flex', justifyContent: 'space-between', margin:'50px 0' }}>
            {/* 科技前沿内容 */}
            <div style={{ width: '60%', paddingLeft: '10%' }}>
              <div style={{borderTop: '1px solid #000', paddingTop: 20}}>
                <div className="directory-item-tag-box">
                  <span style={{margin: '0 10px 0 0'}}>News</span>•
                  <span style={{margin: '0 10px'}}>Nutrition</span>•
                  <span style={{margin: '0 10px', color: 'rgba(0,0,0,0.54)'}}>{selectArticle.time}</span>
                </div>
                <div style={{fontSize:'clamp(32px, calc(27.07px + 1.31vw), 46px)', padding:'24px 0'}}>{selectArticle.title}</div>
                <div style={{fontSize:'clamp(18px, calc(16.94px + 0.28vw), 21px)', color:'rgba(0, 0, 0, 0.54)', padding:'0 0 24px 0'}}>{selectArticle.excerpt}</div>
                <div>{selectArticle.img}</div>
              </div>
  
              <div ref={contentDom} dangerouslySetInnerHTML={{ __html: selectArticle.content }} />
            </div>
  
            {/* 科技前沿目录 */}
            <div style={{ width: '30%', height: 'min-content', position:'sticky', top: 50 }}>
              <div style={{fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)', fontWeight: 500, marginBottom: 20}}>Table of contents</div>
              
              <Divider style={{ borderColor: '#272724', margin:'15px 0' }} />
  
              {directoryList.map((e,i)=>{
                return (
                  <div 
                    key={i} 
                    onClick={() => scrollToAnchor(e.href)}
                    style={{fontSize: 'clamp(16px, calc(15.65px + 0.09vw), 17px)', color: 'rgba(0, 0, 0, 0.54)', margin:'20px 0'}}
                  >
                    {/* <Link to={e.href}>{e.title}</Link> */}
                    {e.title}
                  </div>
                )
              })}
  
              <div 
                onClick={() => scrollToAnchor('root')}
                style={{fontSize: '12px', color: 'rgba(0, 0, 0, 0.54)', margin:'20px 0'}}
              >
                返回顶部
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }else{
    return (
      <div className="ABoutDetail-page" style={{textAlign: 'left'}}>
        <div style={{width: '100%', maxWidth: 1440, margin: '0px auto'}}>

          {/* 科技前沿内容 */}
          <div style={{ display: 'flex', justifyContent: 'space-between', margin:'50px 0' }}>
            {/* 科技前沿内容 */}
            <div style={{ width: '100%', padding: '0 25px' }}>
              <div style={{borderTop: '1px solid #000', paddingTop: 20}}>
                <div className="directory-item-tag-box">
                  <span style={{margin: '0 10px 0 0'}}>News</span>•
                  <span style={{margin: '0 10px'}}>Nutrition</span>•
                  <span style={{margin: '0 10px', color: 'rgba(0,0,0,0.54)'}}>{selectArticle.time}</span>
                </div>
                <div style={{fontSize:'clamp(32px, calc(27.07px + 1.31vw), 46px)', padding:'24px 0'}}>{selectArticle.title}</div>
                <div style={{fontSize:'clamp(18px, calc(16.94px + 0.28vw), 21px)', color:'rgba(0, 0, 0, 0.54)', padding:'0 0 24px 0'}}>{selectArticle.excerpt}</div>
                <div>{selectArticle.img}</div>
              </div>

              <div ref={contentDom} dangerouslySetInnerHTML={{ __html: selectArticle.content }} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ABoutDetail